import { FILTER_OPERATOR_ENUMS, FILTER_RULE_ENUMS } from '@constants';
import { formatDate } from '@utils';
import { omit } from 'lodash-es';

export const normalizeCustomerVehicle = (data = {}) => {
  return {
    ...data,
    // TODO: remove old normalization
    generalInfo: {
      id: {
        label: 'ID',
        renderedValue: data?.id || '-',
      },
      internalId: {
        label: 'Internal ID',
        renderedValue: data?.internalId || '-',
      },
      createdAt: {
        label: 'Created At',
        renderedValue: formatDate(data?.createdAt) || '-',
      },
      updatedAt: {
        label: 'Updated At',
        renderedValue: formatDate(data?.updatedAt) || '-',
      },
    },
    vehicleInfo: {
      manufacturer: {
        label: 'Manufacturer',
        renderedValue: data?.manufacturer || '-',
      },
      model: {
        label: 'Model',
        renderedValue: data?.model || '-',
      },
      plate: {
        label: 'Plate',
        renderedValue: data?.plate || '-',
      },
      type: {
        label: 'Type',
        renderedValue: data?.type || '-',
      },
      vin: {
        label: 'Vin',
        renderedValue: data?.vin || '-',
      },
      year: {
        label: 'Year',
        renderedValue: data?.year || '-',
      },
      color: {
        label: 'Color',
        renderedValue: data?.meta?.color || '-',
      },
      mileage: {
        label: 'Mileage',
        renderedValue: data.mileage,
      },
      tires: {
        label: 'Tire Size',
        renderedValue: data.tires || '-',
      },
    },
    id: data?.id || '-',
    internalId: data?.internalId || '-',
    createdAt: formatDate(data?.createdAt, 'dd/MM/yyyy HH:mm:ss') || '-',
    updatedAt: formatDate(data?.updatedAt, 'dd/MM/yyyy HH:mm:ss') || '-',
    status: data?.status || '-',
    vin: data?.vin || '-',
    plate: data?.plate || '-',
    manufacturer: data?.manufacturer || '-',
    transmission: data?.transmission || '-',
    model: data?.model || '-',
    year: data?.year || '-',
    edition: data?.edition || '-',
    displacement: data?.displacement || '-',
    mileage: data?.mileage || '-',
    fuel: data?.fuel || '-',
    gear: data?.gear || '-',
    type: data?.type || '-',
    tires: data?.tires || '-',
    driverDocuments:
      data?.documents
        ?.filter(
          (doc) =>
            doc.type === 'DriverLicence' ||
            doc.type === 'PersonalIdentification'
        )
        .map((doc) => {
          const document = { ...doc };
          document.fileName = '-';
          return {
            ...document,
            uploadedAt: formatDate(document?.createdAt, 'dd/MM/yyyy HH:mm:ss'),
          };
        }) || [],
    financialDocuments:
      data?.documents
        ?.filter(
          (doc) =>
            doc.type !== 'DriverLicence' ||
            doc.type !== 'PersonalIdentification'
        )
        .map((doc) => {
          const document = { ...doc };
          document.fileName = '-';
          return {
            ...document,
            uploadedAt: formatDate(document?.createdAt, 'dd/MM/yyyy HH:mm:ss'),
          };
        }) || [],
  };
};

export const normalizeCustomerVehicleUsers = (data = []) => {
  return data.map((user) => ({
    id: user.userId,
    name: user?.name || '-',
    email: user?.email || '-',
    role: user?.role || '-',
  }));
};

export const normalizeCustomerVehicles = (data = []) => {
  return data.map((vehicle) => ({
    ...vehicle,
    createdAt: formatDate(vehicle.createdAt, 'dd/MM/yyyy'),
    updatedAt: formatDate(vehicle.updatedAt, 'dd/MM/yyyy') || '-',
  }));
};

export const normalizeBundleTypes = (data = []) => {
  return data.map((bundle) => ({
    ...bundle,
  }));
};

export const normalizeBundles = (data, customerVehicleId) => {
  const bundles = data.filter((bundle) =>
    bundle.customerVehiclesRef?.includes(customerVehicleId)
  );
  return bundles.map((bundle) => ({
    ...bundle,
    createdAt: formatDate(bundle.createdAt, 'dd/MM/yyyy'),
    updatedAt: bundle.updatedAt
      ? formatDate(bundle.updatedAt, 'dd/MM/yyyy')
      : '-',
    name: bundle.bundleType?.name || '-',
    offerings: bundle.bundleType?.offerings || [],
  }));
};

export const normalizeCustomerVehiclesBrands = (data = {}) => {
  if (!data) return [];

  const brands = Object.values(data)
    .filter((item) => item?.name)
    .map((item) => ({
      label: item?.name,
      value: item?.name,
      models: Object.values(item?.models)
        .filter((model) => model?.name)
        .map((model) => ({
          label: model?.name,
          value: model?.name,
        })),
    }));

  return brands || [];
};

export const getSearchRequestPayload = (payload = {}) => {
  const fields = omit(payload, ['page', 'pageSize', 'query']) || {};
  const keys = Object.keys(fields);

  if (keys.length === 0) {
    return null;
  }

  const value = keys.map((key) => {
    if (fields[key].includes(',')) {
      return {
        field: key,
        operator: FILTER_OPERATOR_ENUMS['='],
        type: FILTER_RULE_ENUMS.IsAnyOfRuleType,
        value:
          key === 'year'
            ? fields[key].split(',').map((item) => parseInt(item, 10))
            : fields[key].split(','),
      };
    }

    return {
      field: key,
      operator: FILTER_OPERATOR_ENUMS['='],
      type: FILTER_RULE_ENUMS.ComparableRuleType,
      value: key === 'year' ? parseInt(fields[key], 10) : fields[key],
    };
  });

  return {
    type: 0,
    value,
  };
};
